/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntegrationCreate } from '../models/IntegrationCreate'
import type { IntegrationResource } from '../models/IntegrationResource'
import type { IntegrationSort } from '../models/IntegrationSort'
import type { IntegrationUpdate } from '../models/IntegrationUpdate'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class FeaturesIntegrationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Integrations.
     * @returns any OK
     * @throws ApiError
     */
    public listIntegrations(): CancelablePromise<{
        data: Array<IntegrationResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/integrations',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create Integration.
     * @returns any Created
     * @throws ApiError
     */
    public createIntegration({ requestBody }: { requestBody?: IntegrationCreate }): CancelablePromise<{
        data: IntegrationResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/integrations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Applies a sort order to the integrations.
     * @returns void
     * @throws ApiError
     */
    public sortIntegrations({ requestBody }: { requestBody?: IntegrationSort }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/integrations/sort',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Display the specified resource.
     * @returns any OK
     * @throws ApiError
     */
    public getIntegration({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: IntegrationResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/integrations/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Remove the specified resource from storage.
     * @returns void
     * @throws ApiError
     */
    public deleteIntegration({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/integrations/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update the specified resource in storage.
     * @returns any OK
     * @throws ApiError
     */
    public updateIntegration({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody?: IntegrationUpdate
    }): CancelablePromise<{
        data: IntegrationResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/integrations/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
